const PatientState = ({ error, loading }) => {
    if (error) {
        return <div className="patient-state patient-state--error">{error}</div>;
    }

    if (!loading) {
        return null;
    }

    return (
        <div className="patient-state">
            <div className="patient-state__loader" />
            <p>Cargando datos...</p>
        </div>
    );
};

export default PatientState;
